import { RunningExperiments, useExperiments } from 'state/experiments';

export const useContentCardsNotificationsExperiment = (skipExposureLogging: boolean = false) => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.ContentCardsNotifications, 'treatment', {
    skipExposureLogging,
  });
};
